import React from "react";
import Header from './header'
import '../scss/cp.scss';

import Footer from "./footer";
import { Outlet } from "react-router-dom";
const NewWeb=()=>{
    return(
        <>
        <Header/>
      <Outlet/>
        <Footer/>
        </>
    )
}
export default NewWeb